<template>
  <div class="text-input-container">
    <div
      v-if="label"
      class="input-label-container"
    >
      <label
        v-if="label"
        class="input-label"
      > {{ label }} </label>
      <span
        v-if="showRequired"
        class="required-label"
      >(required)</span>
    </div>
    <input
      v-model="displayValue"
      v-bind="$attrs"
      class="input-field"
      :aria-required="showRequired"
      :aria-label="label"
      :tabindex="disabled ? -1 : 0"
      :class="{disabled: disabled}"
    >
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NumericInput',
  props: {
    modelValue: {
      type: [Number, String],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    showRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    displayValue: {
      get: function(): string | number {
        return this.modelValue
      },
      set: function(modifiedValue: string | number): void {
        const newValueAsString = modifiedValue.toString()
        let newValueAsNumber = parseFloat(newValueAsString.replace(/[^\d.]/g, ''))
        if (isNaN(newValueAsNumber))
          newValueAsNumber = 0

        if (typeof(this.modelValue) === 'string')
          this.$emit('update:modelValue', newValueAsNumber.toString())
        else
          this.$emit('update:modelValue', newValueAsNumber)
      }
    }
  }
})
</script>

<style scoped lang="scss">
.text-input-container {
  text-align: left;

  > .input-label-container {

    > .input-label {
      @include input-text-field-label;
    }

    > .required-label {
      @include input-text-field-label;
      margin-left: 5px;
      font-weight: 300;
    }
  }

  > .input-field {
    @include input-text-field;
  }
}
</style>
